// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3VkVH","gfeWrapper":"CalendarEvent_gfeWrapper__y4d44"};